var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog"},[_c('narrow-content',{attrs:{"title":"Blog博客"}},[_c('blog-item'),_c('blog-item'),_c('blog-item')],1),_c('get-in-touch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }